import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-page-unauthorized',
  templateUrl: './page-unauthorized.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./page-unauthorized.component.scss'],
})
export class PageUnauthorizedComponent {
  @HostBinding('class') hostClass = 'd-flex w-100';
}
